import { render } from "./UnNftMenu.vue?vue&type=template&id=4089752e"
import script from "./UnNftMenu.vue?vue&type=script&lang=js"
export * from "./UnNftMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__